import { EventDeliveryStatusEnum } from "@admin_api/models/event-delivery-status-enum";
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "app-event-deliveries-table-cell-content",
    templateUrl: "./event-deliveries-table-cell-content.component.html",
    styleUrls: ["./event-deliveries-table-cell-content.component.less"],
    standalone: false
})
export class EventDeliveriesTableCellContentComponent {

    @Input() columnId: string;
    @Input() element: any;

    @Output() resend = new EventEmitter<{eventDeliveryId: number; isDelivered: boolean}>();

    constructor() {}

    onClickResend() {
        this.resend.emit({eventDeliveryId: this.element.id, isDelivered: this.element.status === EventDeliveryStatusEnum.Delivered});
    }

}
